<template>
    <div class="row mt-5 mb-3 mx-0 user-list">
        <carousel class="col-md-12 row align-items-start"
            :perPageCustom="[[576,1],[768,2],[992,3],[1200,5]]"
            :scrollPerPage="true" :paginationEnabled="false"
            :navigationEnabled="true">
            <!-- <transition
            enter-active-class="animate__animated animate__bounceInDown"
            mode="out-in" v-if="this.$route.params.slug"> -->
                <slide class="slider-content text-center col-lg-4 col-sm-6 col-12"
                    :class="{hideCurrentShowing: executive.slug === execToSkip}"
                    v-for="executive in executives" :key="executive.id">
                    <router-link :to="`/executives/${executive.slug}`" class="no-underline">
                        <img :src="executive.image_url" class="img-fluid" :alt="executive.title.rendered">
                        <span class="text-normal font-bold d-block">{{ executive.title.rendered }}</span>
                        <span class="text-normal font-italic">{{ executive.designation }}</span>
                    </router-link>
                </slide>
            <!-- </transition> -->
            <!-- <slide class="slider-content text-center col-lg-4 col-sm-6 col-12"
                :class="{hideCurrentShowing: executive.slug === execToSkip}"
                v-for="executive in executives" :key="executive.id">
                <router-link :to="`/executives/${executive.slug}`" class="no-underline">
                    <img :src="executive.image_url" class="img-fluid" :alt="executive.title.rendered">
                    <span class="text-normal font-bold d-block">{{ executive.title.rendered }}</span>
                    <span class="text-normal font-italic">{{ executive.designation }}</span>
                </router-link>
            </slide> -->
        </carousel>
    </div>
</template>

<script>
export default {
    name: 'UserList',
    props: ['executives', 'execToSkip']
}
</script>

<style>
.user-list {
    margin-top: 40px;
}
@media (min-width: 1200px) {
    .slider-content {
        flex: 0 0 15%;
        max-width: 15%;
    }
}
.no-underline, .no-underline:hover {
    text-decoration: none;
}
.user-list .VueCarousel-slide {
    opacity: 1 !important;
}
.hideCurrentShowing {
    display: none;
}
</style>